import React from "react";
import MasterLayout from "../otherImages/MasterLayout";
import EditProductForm from "../components/EditProductForm";
import DefaultTopBar from "../components/DefaultTopBar";

const EditPackagePage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        <DefaultTopBar
            title="Edit Package"
            desc="Edit a product using a form with the following fields:"
        />

        {/* TableDataLayer */}
        <EditProductForm />

      </MasterLayout>

    </>
  );
};

export default EditPackagePage; 
